"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PWAScript = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const PWA_INSTALL_SCRIPT = `(function() {
if ("serviceWorker" in navigator) {
  window.addEventListener("load", function() {
    var SW = navigator.serviceWorker;
    navigator
      .serviceWorker
      .register('/pwa_sw.js')
      .then(function(registration) {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch(function(err) {
        // unregister service worker
        SW.getRegistrations
          ? SW
            .getRegistrations()
            .then(function (sws) {
              sws.forEach(function (sw) {
                sw.unregister();
              })
            })
          : SW.getRegistration && SW
            .getRegistration()
            .then(function (sw) {
              sw && sw.unregister();
            });
        // clean caches
        window.caches && caches.keys && caches
          .keys()
          .then(function (keys) {
            keys.forEach(function (key) {
              caches.delete(key);
            })
          })
      });

  });
  window.addEventListener("beforeinstallprompt", function(event) {
    window.Tea('wap_pwa_install_show');
  });
  window.addEventListener('appinstalled', function(event) {
    window.Tea('wap_pwa_install_click');
  });
}
})()`.trim();
const PWAScript = () => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("link", { rel: "manifest", href: "/manifest.json" }), (0, jsx_runtime_1.jsx)("script", { async: true, src: "https://cdn.jsdelivr.net/npm/pwacompat", crossOrigin: "anonymous" }), (0, jsx_runtime_1.jsx)("meta", { name: "apple-mobile-web-app-capable", content: "yes" }), (0, jsx_runtime_1.jsx)("meta", { name: "apple-mobile-web-app-status-bar-style", content: "#fff" }), (0, jsx_runtime_1.jsx)("meta", { name: "apple-mobile-web-app-title", content: "Lemon8 Web" }), (0, jsx_runtime_1.jsx)("link", { crossOrigin: "anonymous", rel: "apple-touch-icon", sizes: "202x202", href: "https://p16-va.lemon8cdn.com/tos-maliva-p-0000/5d8e5f313d1b470799f8450327ec6dee~tplv-tej9nj120t-scaling:202:0:q75.jpeg" }), (0, jsx_runtime_1.jsx)("meta", { name: "msapplication-TileColor", content: "#fff" }), (0, jsx_runtime_1.jsx)("meta", { name: "theme-color", content: "#fff" }), (0, jsx_runtime_1.jsx)("script", { type: "application/javascript", dangerouslySetInnerHTML: { __html: PWA_INSTALL_SCRIPT } })] }));
};
exports.PWAScript = PWAScript;
